// extracted by mini-css-extract-plugin
module.exports = {"btnGroup":"blog-module--btnGroup--2SnPx","btn":"blog-module--btn--__I38","item":"blog-module--item--B7gQZ","list":"blog-module--list--3fwsp"};